function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckboxBlankOutline from 'vue-material-design-icons/CheckboxBlankOutline';
import CheckboxBlank from 'vue-material-design-icons/CheckboxBlank';
import MinusBox from 'vue-material-design-icons/MinusBox';
import CheckboxMarked from 'vue-material-design-icons/CheckboxMarked';
import RadioboxMarked from 'vue-material-design-icons/RadioboxMarked';
import RadioboxBlank from 'vue-material-design-icons/RadioboxBlank';
import ToggleSwitchOff from 'vue-material-design-icons/ToggleSwitchOff';
import ToggleSwitch from 'vue-material-design-icons/ToggleSwitch';
export default {
  name: 'Checkbox',
  props: {
    /**
     * Unique id attribute of the input
     */
    id: {
      type: String,
      required: true,
      validator: function validator(id) {
        return id.trim() !== '';
      }
    },

    /**
     * Checked state. To be used with `:value.sync`
     */
    checked: {
      type: [Boolean, Array, String],
      default: false
    },

    /**
     * Value to be synced on check
     */
    value: {
      type: String,
      default: null
    },

    /**
     * Disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Indeterminate state
     */
    indeterminate: {
      type: Boolean,
      default: false
    },

    /**
     * Wrapping element tag
     */
    wrapperElement: {
      type: String,
      default: 'span'
    },

    /**
     * Input name. Required for radio, optional for checkbox
     */
    name: {
      type: String,
      default: null
    }
  },
  computed: {
    /**
     * Icon size
     *
     @return {number}
     */
    size: function size() {
      return 24;
    },

    /**
     * Css local variables for this component
     *
     * @return {object}
     */
    cssVars: function cssVars() {
      return {
        '--icon-size': this.size + 'px'
      };
    },
    isChecked: function isChecked() {
      return _toConsumableArray(this.checked).indexOf(this.value) > -1;
    },

    /**
     * Returns the proper Material icon depending on the select case
     *
     * @return {Component}
     */
    checkboxRadioIconElement: function checkboxRadioIconElement() {
      if (this.indeterminate) {
        return MinusBox;
      }

      if (this.disabled && !this.isChecked) {
        return CheckboxBlank;
      }

      if (this.isChecked) {
        return CheckboxMarked;
      }

      return CheckboxBlankOutline;
    }
  },
  methods: {
    onToggle: function onToggle() {
      if (this.disabled) {
        return;
      } // If the initial value was a boolean, let's keep it that way


      if (typeof this.checked === 'boolean') {
        this.$emit('update:checked', !this.isChecked);
        return;
      } // Dispatch the checked values as an array if multiple, or single value otherwise


      var values = this.getInputsSet().filter(function (input) {
        return input.checked;
      }).map(function (input) {
        return input.value;
      });
      this.$emit('update:checked', values);
    },

    /**
     * Get the input set based on this name
     *
     * @return {Node[]}
     */
    getInputsSet: function getInputsSet() {
      return _toConsumableArray(document.getElementsByName(this.name));
    }
  }
};